import { Moon, Mountain, Sun } from "lucide-react";
import { Stack, useMediaQuery, useTheme } from "@mui/material";
import { palette } from "@powerdiary/components-library/lib";
import SchedulePeriodRow from "../SchedulePeriodRow";
import TimePeriodLabel from "../TimePeriodLabel";

interface IAvailableTimePickerProps {
    generalValue: number;
    onChange: (value: number) => void;
}

const timePeriods = [
    { label: "Morning", icon: Mountain, backgroundColor: palette.dusk[200] },
    { label: "Afternoon", icon: Sun, backgroundColor: palette.sunflower[300] },
    { label: "Evening", icon: Moon, backgroundColor: palette.twilight[100] },
];

export default function AvailableTimePicker({ generalValue, onChange }: IAvailableTimePickerProps) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("xs"));

    return (
        <Stack spacing={isMobile ? 1 : 0}>
            {timePeriods.map((period, rowIndex) => (
                <SchedulePeriodRow
                    key={period.label}
                    label={
                        <TimePeriodLabel
                            label={period.label}
                            icon={period.icon}
                            backgroundColor={period.backgroundColor}
                        />
                    }
                    onChange={onChange}
                    generalValue={generalValue}
                    rowIndex={rowIndex}
                />
            ))}
        </Stack>
    );
}
